import  store  from '@/store'
export default function (Vue) {
  Vue.loadingDialog = {
    show (message = '', color = 'primary') {
      const loadingDialog = { color,  message }
      store.commit('showLoadingDialog', loadingDialog)
    },
    hide () {
      store.commit('hideLoadingDialog')
    },
    reset () {
      store.commit('resetLoadingDialog')
    }
  }
  Object.defineProperties(Vue.prototype, {
    $loadingDialog: {
      get: () => {
        return Vue.loadingDialog
      }
    }
  })
}
